import { render, staticRenderFns } from "./LockedContent.vue?vue&type=template&id=5831e6c2&scoped=true"
import script from "./LockedContent.vue?vue&type=script&lang=js"
export * from "./LockedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831e6c2",
  null
  
)

export default component.exports